var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 9.394V.5h8.894v8.894zM.5 20.5v-8.894h8.894V20.5zM11.606 9.394V.5H20.5v8.894zm0 11.106v-8.894H20.5V20.5zM1.462 8.433h6.97V1.462h-6.97zm11.105 0h6.971V1.462h-6.97zm0 11.106h6.971v-6.972h-6.97zm-11.105 0h6.97v-6.972h-6.97z"
  })));
};
export default SvgGrid;